<template>
  <div class="invite">
    <div class="content">
      <div class="logo">
        <img src="@/assets/image/invite/logo.png" alt="">
      </div>
      <div class="layout">
        <div class="form">
          <div class="form-item">
            <input class="input" type="text" v-model="form.customerName" placeholder="请输入姓名">
          </div>
          <div class="form-item">
            <input class="input" type="text" maxlength="11" v-model="form.customerPhone" placeholder="请输入手机号码">
          </div>
          <div class="form-item code-item">
            <input class="input" type="text" v-model="form.code" placeholder="输入验证码">
            <div class="img" @click="getCode()">
              <img :src="codeImg" alt="">
            </div>
          </div>
          <div class="form-item">
            <input class="input" type="text" v-model="form.customerCompany" placeholder="请输入公司名称">
          </div>
          <div class="form-item">
            <input class="input" type="text" v-model="form.customerCity" placeholder="请输入所在城市">
          </div>
          
          <div class="form-radio">
            <div class="label">信息来源:</div>
            <label for="network" class="radio-item">
              <input name="customerResource" v-model="form.customerResource" value="0" type="radio"> 网络推广
            </label>
            <label for="daili" class="radio-item">
              <input name="customerResource" v-model="form.customerResource" value="1" type="radio"> 区域代理
            </label>
          </div>
          <div class="submit" @click="submitForm">申请测试</div>
        </div>
      </div>
      <div class="intro">
        <div class="intro-title">深圳市景悦科技有限公司</div>
        <!--<div class="intro-br">/</div>-->
        <div class="intro-subtitle">www.szgenjoy.com</div>
        <!--<div class="intro-br">/</div>-->
        <div class="intro-content">
          <div class="intro-items">
            <div class="intro-item">0755-23625181</div>
            <div class="intro-item">contact@szgenjoy.com</div>
            <div class="intro-item">深圳市福田区深南大道6011号NEO企业大厦A座61层</div>
          </div>
        </div>
      </div>
      <div class="apps-download">
        <div class="code">
          <img src="@/assets/image/invite/code.png" alt="">
          <span>景悦公众号</span>
        </div>
        <a href="https://oss-public.uopgenjoy.com/uat/apps/android/uat-property.html" class="app-item">
          <img src="@/assets/image/invite/property.png" alt="">
          <span>悦享住测试APP</span>
        </a>
        <a href="https://oss-public.uopgenjoy.com/uat/apps/android/uat-employee.html" class="app-item">
          <img src="@/assets/image/invite/employee.png" alt="">
          <span>憬悦管家测试APP</span>
        </a>
      </div>
			<div class="download-tip">目前APP下载只支持安卓手机</div>
    </div>
    <div class="modal" v-if="showTip">
      <div class="mask"></div>
      <div class="modal-content">
        <div class="modal-title">温馨提示</div>
        <div class="modal-msg">申请成功<br/>请注意查收您的短信</div>
        <div class="modal-foot">
          <div class="btn" @click="showTip = false">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NetService } from '@/service'
import { Toast } from 'vant'
export default {
  data () {
    return {
      codeImg: '',
      showTip: false,
      form: {
        customerCity: '',
        customerCompany: '',
        customerName: '',
        customerPhone: '',
        customerResource: '',
        code: ''
      }
    }
  },
  computed: {
    isFull() {
      return this.form.customerCity && (this.form.customerResource === 0 || this.form.customerResource) && this.form.customerName && this.form.customerPhone && this.form.customerCompany
    }
  },
  created() {
	this.getCode()
  },
  methods: {
	// 获取图形验证码
	getCode() {
		let url = process.env.NODE_ENV === 'development' ? 'https://uop-uat.szgenjoy.com/public/intentional/getVerifyCode?' : '/public/intentional/getVerifyCode?'
		this.codeImg = url + new Date().getTime()
	},
    // 提交客户信息
    submitForm() {
      if (!this.isFull) return Toast({ duration: 2000, message: '请填写完整表单' })
      let loading = Toast.loading({ duration: 0, message: '正在提交...' })
      NetService.Invite(this.form).then(() => {
        loading.clear()
        this.getCode()
        this.showTip = true
        // if (res) {
        // Toast({ duration: 1500, message: '申请成功，请注意查收您的短信' })
        // }
      }).catch((err) => {
        Toast({ duration: 2000, message: err.msg })
        this.getCode()
        // loading.clear()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.invite {
	min-height: 100vh;
	background: url(../assets/image/invite/bg.png) no-repeat center center;
	background-color: $color-bg;
	background-size: 100% 100%;
	font-size: 12px;

	@extend .flex-column;
	.content {
		position: relative;
		z-index: 5;
		.logo {
			padding: 76px 40px 55px;
			img {
				display: block;
				margin: 0 auto;
				width: 297px;
				height: 52px;
			}
		}
	}
	.layout {
		margin: 0 40px 0;
		padding-bottom: 40px;
		border-radius: 10px;
		background: rgba(255, 255, 255, .1);
		.form {
			padding-top: 65px;
			.form-item {
				display: flex;
				overflow: hidden;
				align-items: center;
				margin: 0 60px 44px;
				padding: 0 30px;
				border-radius: 10px;
				height: 71px;
				background: rgba(255, 255, 255, 1);
				.input {
					flex: 1;
					margin: 0;
					padding: 0;
					outline: none;
					background: none;
					color: #333;

					@include text(28px);
				}
				&.code-item {
					justify-content: space-between;
					padding: 0 0 0 30px;
					.input {
						width: 100%;
					}
					.img {
						padding: 8px 15px;
						border-radius: 0 10px 10px 0;
						width: 200px;
						height: 71px;
						img {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
			.form-radio {
				display: flex;
				align-items: center;
				margin: 0 60px 44px;
				.label {
					font-weight: 400;
					color: #fff;
          font-size: 24px;
				}
				.radio-item {
					font-weight: 400;
					color: #fff;
          font-size: 24px;
				}
			}
			.submit {
				margin: 0 60px;
				border-radius: 10px;
				height: 71px;
				background: #20d2dd;
				line-height: 71px;
				text-align: center;
				font-weight: bold;
				color: #fff;
        font-size: 36px;
			}
		}
	}
}
.intro {
	padding: 30px 88px 0;
	line-height: 1.2;
	font-size: 24px;
	.intro-title {
		color: #fff;
		// height: 46px;
    font-size: 30px;
		// text-align: center;
		// margin: 0 0 0;
	}
	.intro-br {
		padding: 10px 0;
		font-size: 40px;
		// text-align: center;
		color: #fff;
	}
	.intro-subtitle {
		margin-top: 8px;
		// text-align: center;
		// @include text(26px);
		color: #fff;
	}
	.intro-content {
		display: flex;
		margin-top: 8px;
		// margin: 0 30px;
		font-size: 26px;
	}
	.intro-item {
		// padding-bottom: 15px;
		margin-top: 8px;
		font-weight: 400;
		color: #fff;
    font-size: 24px;
	}
	.code {
		// text-align: center;
		// padding-bottom: 46px;
		// flex: 1;
		// img {
		//   display: block;
		//   margin: 0 auto;
		//   width: 142px;
		//   height: 142px;
		//   border: 1px solid #fff;
		//   padding: 5px;;
		// }
	}
}
.apps-download {
	display: flex;
	justify-content: space-between;
	margin: 25px 75px 0;
	padding-bottom: 20px;
	text-align: center;
	a,
	.code {
		display: inline-block;
		// margin: 0 30px;
		width: 30%;
		text-decoration: none;
		color: #fff;
		img {
			width: 100%;
		}
		span {
			display: block;
			margin-top: 10px;
			font-size: 24px;
		}
	}
}
.download-tip {
	text-align: center;
	color: #fff;
	margin-bottom: 20px;
}
.modal {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 999;
	.mask {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 1000;
		background: rgba(0, 0, 0, .4);
	}
	.modal-content {
		position: absolute;
		left: 50%;
		top: 50%;
		z-index: 1001;
		margin-left: -250px;
		margin-top: -200px;
		border-radius: 10px;
		width: 500px;
		height: 380px;
		background: #fff;
		.modal-title {
			border-bottom: 1px solid #eee;
			line-height: 100px;
			text-align: center;
			font-size: 28px;
		}
		.modal-msg {
			padding: 40px 60px;
			line-height: 50px;
			text-align: center;
			font-size: 30px;
			color: #3acb7b;
		}
		.modal-foot {
			.btn {
				border-top: 1px solid #eee;
				height: 100px;
				line-height: 100px;
				text-align: center;
				font-size: 30px;
			}
		}
	}
}
</style>
